export const QuestionnairesAssistant = {
    "Questionnaires": {
        items: [
            //Creating a questionnaire template
            {
                heading: 'Creating a questionnaire template',
                permissions: ['System Admin'],
                tags: ['questionnaire', 'create'],
                sections: [
                    {
                        description: 'Navigate to the questionnaire builder',
                        styleAs: 'list',
                    },
                    {
                        description: 'Enter a name for the questionnaire on the new section',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select <b>Next</b>',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to the questionnaire builder',
                        action: {
                            type: 'location',
                            value: '/sys-admin/questionnaires/builder',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            //Approving a questionnaire template
            {
                heading: 'Approving a questionnaire template',
                permissions: ['System Admin'],
                tags: ['questionnaire', 'aprrov'],
                sections: [
                    {
                        description: 'Navigate to the questionnaire builder',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select the <b>Awaiting Approval</b> tab',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select the item to approve',
                        styleAs: 'list',
                    },
                    {
                        description: 'Review the item',
                        styleAs: 'note',
                    },
                    {
                        description: 'Select approve from the toast on the top left of the screen',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to the questionnaire builder',
                        action: {
                            type: 'location',
                            value: '/sys-admin/questionnaires/builder',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
        ]
    }
}